var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainScreenLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3481 0.0127273L6.08874 0C4.6302 0 3.43686 1.14545 3.43686 2.54545V6.36364C3.43686 7.06364 4.03353 7.63636 4.7628 7.63636C5.49206 7.63636 6.08874 7.06364 6.08874 6.36364V5.09091H19.3481V22.9091H6.08874V21.6364C6.08874 20.9364 5.49206 20.3636 4.7628 20.3636C4.03353 20.3636 3.43686 20.9364 3.43686 21.6364V25.4545C3.43686 26.8545 4.6302 28 6.08874 28H19.3481C20.8067 28 22 26.8545 22 25.4545V2.54545C22 1.14545 20.8067 0.0127273 19.3481 0.0127273ZM10.0666 17.8182C10.7958 17.8182 11.3925 17.2455 11.3925 16.5455V10.1818C11.3925 9.48182 10.7958 8.90909 10.0666 8.90909H3.43686C2.70759 8.90909 2.11092 9.48182 2.11092 10.1818C2.11092 10.8818 2.70759 11.4545 3.43686 11.4545H6.87104L0.387201 17.6782C0.13928 17.9162 0 18.2389 0 18.5755C0 18.912 0.13928 19.2348 0.387201 19.4727C0.635122 19.7107 0.971375 19.8444 1.32199 19.8444C1.6726 19.8444 2.00885 19.7107 2.25677 19.4727L8.74061 13.2491V16.5455C8.74061 17.2455 9.33729 17.8182 10.0666 17.8182Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainScreenLight);
export default __webpack_public_path__ + "static/media/main_screen_light.a7295ad1d222c1796ba7679927e4ac76.svg";
export { ForwardRef as ReactComponent };